module.exports = __webpack_public_path__ + "img/checkmark-white.e8242e44.svg";